import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import { Store } from '@ngrx/store';
import { AppState } from '../../../app/app.reducer';
import { CajaProvider } from '../../caja/caja';
import { SetGestionpedidosAction, UnsetGestionpedidosAction  } from '../../../pages/meseromesero/state/gestionpedidos/gestionpedidos.accions';

@Injectable()
export class GestionPedidosRedux {

  constructor(private store: Store<AppState>,
    public servicio: CajaProvider) {
  }

  buscarGruposProductosGestionPedidosStore() {
    return new Promise((resolve, reject) => {
       this.store.select(store => store.gestionpedidos).subscribe((gestionpedidos) => {
         return resolve(gestionpedidos)
       })
     });
   }

   buscarGruposProductosParaCajaRedux(companiasId: any){
    this.servicio.buscarGruposProductosParaCajaComandas(companiasId).subscribe(
        res => {
          res = JSON.parse(res['_body']).data
          this.store.dispatch(new UnsetGestionpedidosAction())
          this.store.dispatch(new SetGestionpedidosAction(res));
        },
        err => {

        }
      )
}

}



// WEBPACK FOOTER //
// ./src/providers/redux/gestionpedidos/gestionpedidos.ts